import React from 'react';
import { SectionWrapper, SectionTitle } from 'resources/styles/CommonStyles';
import { UserInfoDto } from 'services/data-contracts';
import dayjs from 'dayjs';
import { Button, Row } from 'saladsoft-primitive';
import ServiceHelper from 'stores/ServiceHelper';
import { toast } from 'react-toastify';
import { useStoreWrapper } from 'stores/StoreHelper';

const UserForm = ({ user }: { user: UserInfoDto }) => {
  const { uiStore } = useStoreWrapper();

  const handleAdminRole = (isAdmin: boolean) => {
    const service = isAdmin
      ? ServiceHelper?.userService.setAdminRole
      : ServiceHelper?.userService.unsetAdminRole;

    service(user.id as number)
      .then(() => {
        toast.success(
          user.isAdmin ? '관리자 해제가 완료되었습니다.' : '관리자 지정이 완료되었습니다.',
        );
        uiStore?.modal.close();
      })
      .catch((err) => {
        toast.error(err.response.data.message);
      });
  };

  const handleAccountActivation = () => {
    ServiceHelper?.userService
      .approveUser(user.id as number)
      .then(() => {
        toast.success('계정활성화가 완료되었습니다.');
        uiStore?.modal.close();
      })
      .catch((err) => {
        toast.error(err.response.data.message);
      });
  };

  const handleWithdraw = (activate: boolean) => {
    if (activate) {
      ServiceHelper?.userService.unwithdrawUser(user.id as number).then(() => {
        toast.success('계정활성화가 완료되었습니다.');
        uiStore?.modal.close();
      });
    } else {
      ServiceHelper?.userService
        .withdrawUser(user.id as number)
        .then(() => {
          toast.success('계정비활성화가 완료되었습니다.');
          uiStore?.modal.close();
        })
        .catch((err) => {
          toast.error(err.response.data.message);
        });
    }
  };

  return (
    <div style={{ padding: '0 20px' }}>
      <SectionWrapper>
        <SectionTitle>사용자명</SectionTitle>
        <div>{user.username}</div>
      </SectionWrapper>
      <SectionWrapper>
        <SectionTitle>이름</SectionTitle>
        <div>{user.profile?.name}</div>
      </SectionWrapper>
      <SectionWrapper>
        <SectionTitle>가입일</SectionTitle>
        <div>{dayjs(user.signupDate).format('YYYY-MM-DD')}</div>
      </SectionWrapper>
      <SectionWrapper>
        <SectionTitle>탈퇴여부</SectionTitle>
        <div>{user.isWithdrawn ? '탈퇴' : '활성'}</div>
      </SectionWrapper>
      <>{!user.isVerify && <Button onClick={() => handleAccountActivation()}>활성화</Button>}</>
      {user.isVerify && (
        <Row justifyContent="space-between">
          <div>
            {user.isWithdrawn ? (
              <Button onClick={() => handleWithdraw(true)}>활성화</Button>
            ) : (
              <Button onClick={() => handleWithdraw(false)}>비활성화</Button>
            )}
          </div>
          <div>
            {!user.isAdmin && <Button onClick={() => handleAdminRole(true)}>관리자지정</Button>}
            {user.isAdmin && (
              <Button style={{ backgroundColor: '#880000' }} onClick={() => handleAdminRole(false)}>
                관리자 해제
              </Button>
            )}
          </div>
        </Row>
      )}
    </div>
  );
};

export default UserForm;
